// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>49</span>&nbsp;&nbsp;Where, O Lord, is your steadfast love of old,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;which you swore to David in your faithfulness?<br> </p> </div></div>";
// Exports
module.exports = code;